import { useQuery } from '@tanstack/react-query';

import { kubesoloOfflineBundleList } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';

import { queryKeys } from './queryKeys';

export function useOfflineBundles() {
  return useQuery({
    queryKey: queryKeys.offlineBundles(),
    queryFn: async () => {
      const { data } = await kubesoloOfflineBundleList();
      return data;
    },
    ...withError('Unable to load the offline bundles'),
  });
}
